<mode-format-dropdown-list
  [label]="'Scale type'"
  [menuItems]="menuItems"
  [selected]="selected"
  (selectedChange)="selectItem($event)"
></mode-format-dropdown-list>
